// @ts-ignore
import React from "react";

import ImageChecklistSide from "@/patterns/image-checklist-side";

const Reports = () => {
    const title = "Reports and insights";
    const listItems = [
        <>
            <strong>Ready to go reporting:</strong> Out-of-the-box reports and
            dashboards in Jira Software offer critical insights within the
            context of your work to ensure your teams are always up to date and
            set up for success.
        </>,
        <>
            <strong>Sprint reporting:</strong> Determine where your team is
            overcommitted to reduce excessive scope creep and better understand
            completed work in each sprint.
        </>,
        <>
            <strong>Burndown chart:</strong> Track work towards sprint goals to
            manage progress and respond accordingly.
        </>,
        <>
            <strong>Release Burndown:</strong> Track and monitor the projected
            release date for versions and take action if work is falling behind
            schedule.
        </>
    ];
    const imageSrc =
        "https://wac-cdn-2.atlassian.com/dam/jcr:dc52a8ec-a4a9-43bb-a1f3-973ee4978762/JSW_Reports.png?cdnVersion=ecc";
    const imageAlt = "Jira reports";

    return (
        <ImageChecklistSide
            title={title}
            listItems={listItems}
            imageSrc={imageSrc}
            imageAlt={imageAlt}
        />
    );
};

export default Reports;
